var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCurrentUserIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_87823",
    "data-name": "Group 87823",
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14977",
    "data-name": "Rectangle 14977",
    width: 27,
    height: 27,
    rx: 7,
    fill: "#d7faef"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(6 5.945)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1545",
    "data-name": "Ellipse 1545",
    cx: 3.979,
    cy: 3.979,
    r: 3.979,
    transform: "translate(3.437)",
    fill: "#0ccda5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_106618",
    "data-name": "Path 106618",
    d: "M9.7,19.365a4.518,4.518,0,0,1,.055-6.217q-.532-.041-1.086-.042a10.767,10.767,0,0,0-5.853,1.5A3.1,3.1,0,0,0,1.25,17.085v1.049a1.23,1.23,0,0,0,1.23,1.23Z",
    transform: "translate(-1.25 -4.523)",
    fill: "#0ccda5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_15",
    "data-name": "Subtraction 15",
    d: "M3.8,7.6A3.8,3.8,0,1,1,7.6,3.8,3.8,3.8,0,0,1,3.8,7.6ZM1.917,3.466a.45.45,0,0,0-.319.768L2.774,5.41a.45.45,0,0,0,.637,0L6,2.822a.45.45,0,0,0-.637-.636L3.093,4.456,2.235,3.6A.447.447,0,0,0,1.917,3.466Z",
    transform: "translate(7.959 7.963)",
    fill: "#0ccda5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrentUserIcon);
export default __webpack_public_path__ + "static/media/current_user_icon.dc8ef861.svg";
export { ForwardRef as ReactComponent };